export const SHADE_GUIDE_STEPS = [
  { label: 'Select Color', id: 'color' },
  { label: 'Select Material', id: 'material' },
  { label: 'Get Recipe', id: 'recipe' },
]

export enum RECIPE_TYPE {
  SINGLE_ZONE = 'single dentin',
  TRIPLE_ZONE = 'triple dentin',
}

export enum RESTORATION_METHOD {
  STAINING = 'staining',
  LAYERING = 'layering',
}

export const COLOR_FORM = {
  recipeType: {
    label: 'shadeGuideAI.colorForm.recipeType.label',
    tooltip: 'shadeGuideAI.colorForm.recipeType.tooltip',
    options: [
      {
        value: RECIPE_TYPE.SINGLE_ZONE,
        label: 'shadeGuideAI.colorForm.recipeType.options.single',
      },
      {
        value: RECIPE_TYPE.TRIPLE_ZONE,
        label: 'shadeGuideAI.colorForm.recipeType.options.triple',
      },
    ],
  },
  targetShade: {
    label: 'shadeGuideAI.colorForm.targetShade.label',
    tooltip: 'shadeGuideAI.colorForm.targetShade.tooltip',
  },
}

export const MATERIAL_FORM = {
  frameworkColor: {
    label: 'shadeGuideAI.materialForm.frameworkColor.label',
    tooltip: 'shadeGuideAI.materialForm.frameworkColor.tooltip',
  },
  frameworkThickness: {
    label: 'shadeGuideAI.materialForm.frameworkThickness.label',
    tooltip: 'shadeGuideAI.materialForm.frameworkThickness.tooltip',
  },
  stainingBrand: {
    label: 'shadeGuideAI.materialForm.stainingBrand.label',
    tooltip: 'shadeGuideAI.materialForm.stainingBrand.tooltip',
  },
  ceramicBrand: {
    label: 'shadeGuideAI.materialForm.ceramicBrand.label',
    tooltip: 'shadeGuideAI.materialForm.ceramicBrand.tooltip',
  },
  availableSpace: {
    label: 'shadeGuideAI.materialForm.availableSpace.label',
    tooltip: 'shadeGuideAI.materialForm.availableSpace.tooltip',
  },
}

interface Option {
  order: number
  [key: string]: any
}

export const getOptions = (metadata: Record<string, any>, key: string) =>
  metadata?.[key as keyof typeof metadata]
    ?.flat()
    ?.sort((a: Option, b: Option) => a.order - b.order)

export enum COLOR_VALUE {
  LabColor = 'l*a*b Color',
  Vita3DMaster = 'VITA3D Master',
  VitaClassic = 'VITA Classic',
  NaturalDieMaterial = 'Natural Die Material',
}

export const PREP_DROPDOWN_OPTIONS = [
  { value: COLOR_VALUE.LabColor, text: COLOR_VALUE.LabColor },
  { value: COLOR_VALUE.Vita3DMaster, text: COLOR_VALUE.Vita3DMaster },
  { value: COLOR_VALUE.VitaClassic, text: COLOR_VALUE.VitaClassic },
  {
    value: COLOR_VALUE.NaturalDieMaterial,
    text: COLOR_VALUE.NaturalDieMaterial,
  },
]

export const TARGET_DROPDOWN_OPTIONS = [
  { value: COLOR_VALUE.Vita3DMaster, text: COLOR_VALUE.Vita3DMaster },
  { value: COLOR_VALUE.VitaClassic, text: COLOR_VALUE.VitaClassic },
]
